import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '', email: '', company: '', subject: '', message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const mailtoLink = `mailto:info@sarvanta.ai?subject=${encodeURIComponent(formData.subject || 'Website Inquiry')}&body=${encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\nCompany: ${formData.company}\n\n${formData.message}`
    )}`;
    window.location.href = mailtoLink;
    setSubmitted(true);
  };

  const inputStyle = {
    width: '100%', padding: '12px 16px', backgroundColor: '#0a1628',
    border: '1px solid #1a2744', borderRadius: '8px', color: '#fff',
    fontSize: '1rem', outline: 'none', boxSizing: 'border-box'
  };

  const labelStyle = {
    display: 'block', color: '#a0aec0', marginBottom: '6px', fontSize: '0.9rem'
  };

  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '60px 40px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>Contact Us</h1>
        <p style={{ color: '#a0aec0', fontSize: '1.1rem', marginBottom: '50px', lineHeight: '1.7' }}>
          Have a question about our platform, need a demo, or want to discuss a partnership?
          We'd love to hear from you.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px' }}>
          {/* Contact Form */}
          <div>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '24px' }}>Send a Message</h2>
            {submitted ? (
              <div style={{
                padding: '24px', backgroundColor: '#0a1628', borderRadius: '12px',
                border: '1px solid #1a2744', textAlign: 'center'
              }}>
                <p style={{ color: '#60a5fa', fontSize: '1.1rem' }}>
                  Thank you! Your email client should open with your message. If it didn't,
                  please email us directly at info@sarvanta.ai.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div>
                  <label style={labelStyle}>Full Name *</label>
                  <input type="text" name="name" required value={formData.name}
                    onChange={handleChange} style={inputStyle} placeholder="Your name" />
                </div>
                <div>
                  <label style={labelStyle}>Email Address *</label>
                  <input type="email" name="email" required value={formData.email}
                    onChange={handleChange} style={inputStyle} placeholder="you@company.com" />
                </div>
                <div>
                  <label style={labelStyle}>Company</label>
                  <input type="text" name="company" value={formData.company}
                    onChange={handleChange} style={inputStyle} placeholder="Your company" />
                </div>
                <div>
                  <label style={labelStyle}>Subject *</label>
                  <input type="text" name="subject" required value={formData.subject}
                    onChange={handleChange} style={inputStyle} placeholder="How can we help?" />
                </div>
                <div>
                  <label style={labelStyle}>Message *</label>
                  <textarea name="message" required rows="5" value={formData.message}
                    onChange={handleChange} style={{ ...inputStyle, resize: 'vertical' }}
                    placeholder="Tell us about your project or question..." />
                </div>
                <button type="submit" style={{
                  padding: '14px 32px', backgroundColor: '#2563eb', color: '#fff',
                  borderRadius: '8px', border: 'none', fontWeight: '600', fontSize: '1rem',
                  cursor: 'pointer', marginTop: '8px'
                }}>Send Message</button>
              </form>
            )}
          </div>

          {/* Contact Info */}
          <div>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '24px' }}>Get in Touch</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <div style={{
                padding: '24px', backgroundColor: '#0a1628', borderRadius: '12px',
                border: '1px solid #1a2744'
              }}>
                <h3 style={{ color: '#60a5fa', marginBottom: '8px', fontSize: '1rem' }}>Email</h3>
                <a href="mailto:info@sarvanta.ai" style={{ color: '#a0aec0', textDecoration: 'none' }}>
                  info@sarvanta.ai
                </a>
              </div>

              <div style={{
                padding: '24px', backgroundColor: '#0a1628', borderRadius: '12px',
                border: '1px solid #1a2744'
              }}>
                <h3 style={{ color: '#60a5fa', marginBottom: '8px', fontSize: '1rem' }}>Website</h3>
                <a href="https://www.sarvanta.ai" target="_blank" rel="noopener noreferrer"
                  style={{ color: '#a0aec0', textDecoration: 'none' }}>
                  www.sarvanta.ai
                </a>
              </div>

              <div style={{
                padding: '24px', backgroundColor: '#0a1628', borderRadius: '12px',
                border: '1px solid #1a2744'
              }}>
                <h3 style={{ color: '#60a5fa', marginBottom: '8px', fontSize: '1rem' }}>Response Time</h3>
                <p style={{ color: '#a0aec0', margin: 0 }}>
                  We typically respond within one business day.
                </p>
              </div>

              <div style={{
                padding: '24px', backgroundColor: '#0a1628', borderRadius: '12px',
                border: '1px solid #1a2744'
              }}>
                <h3 style={{ color: '#60a5fa', marginBottom: '8px', fontSize: '1rem' }}>Support</h3>
                <p style={{ color: '#a0aec0', margin: 0 }}>
                  Existing customers can also reach us through the chat widget on this page.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
